export const SET_PAYMENT_STRIPE_ACCOUNT = 'SET_PAYMENT_STRIPE_ACCOUNT'
export const SET_PAYPAL_NOTIFICATION = 'SET_PAYPAL_NOTIFICATION'
export const SET_STRIPE_NOTIFICATION = 'SET_STRIPE_NOTIFICATION'
export const SET_TAP2PAY_NOTIFICATION_MODAL_SHOW = 'SET_TAP2PAY_NOTIFICATION_MODAL_SHOW'
export const SET_ADYEN_CONNECTED_ACCOUNT = 'SET_ADYEN_CONNECTED_ACCOUNT'
